import { Palette, FileText, ListChecks, CalendarRange, Globe2, Receipt, Building2, Sparkles } from "lucide-react";
import { Reveal, SectionHead } from "./Section";
import { EmailSetupButton } from "./EmailCta";

const ITEMS = [
  [Palette, "Your logo and colours", "On the app, job reports, invoices and payroll PDFs."],
  [FileText, "Your ABN and address", "Printed on every report, invoice and statement."],
  [ListChecks, "Job types for your trade", "Plastering, mowing, cleaning — or your own list."],
  [CalendarRange, "Your pay period", "Weekly or fortnightly, starting on the day you choose."],
  [Globe2, "Your time zone", "Every time shown in your state's time."],
  [Receipt, "Your invoice settings", "Hourly or per-job pricing, GST, terms, bank details and numbering."],
  [Building2, "Settings per depot", "Each depot can keep its own invoice and bank details."],
  [Sparkles, "Need something else?", "Send a change request and we can build it just for your company."],
];

const Profile = () => (
  <div className="rounded-2xl bg-[#0B1120] text-white p-6 sm:p-7 shadow-2xl home-noise" data-testid="home-customise-profile">
    <div className="flex items-center gap-3">
      <span className="w-12 h-12 rounded-xl bg-[#EA580C] grid place-items-center font-display font-extrabold text-lg">SC</span>
      <div><p className="font-display font-bold text-lg leading-tight">Southern Cross Plastering</p><p className="text-xs text-slate-400 font-mono">ABN 12 345 678 901</p></div>
    </div>
    <dl className="mt-6 grid grid-cols-2 gap-4 text-sm">
      {[["Pay period", "Fortnightly · Mon"], ["Time zone", "Melbourne (VIC)"], ["Invoices", "INV-0048 · GST on"], ["Depots", "North Yard, Geelong"]].map(([k, v]) => (
        <div key={k}><dt className="text-[11px] uppercase tracking-wide text-slate-500 font-semibold">{k}</dt><dd className="mt-1 font-semibold">{v}</dd></div>
      ))}
    </dl>
    <div className="mt-6 flex items-center gap-2">
      {["#1E3A5F", "#EA580C", "#0F766E", "#F8FAFC"].map((c) => <span key={c} className="w-7 h-7 rounded-full border-2 border-white/20" style={{ background: c }} />)}
      <span className="ml-2 text-xs text-slate-400">Brand colours</span>
    </div>
    <div className="mt-5 flex flex-wrap gap-2">
      {["Set & sand", "Cornice", "Delivery", "Site clean"].map((t) => <span key={t} className="rounded-full bg-white/10 px-3 py-1 text-xs font-semibold">{t}</span>)}
    </div>
  </div>
);

export const MakeItYours = () => (
  <section id="customise" className="scroll-mt-16 bg-white py-24 lg:py-32" data-testid="home-customise">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[0.9fr_1.1fr] gap-14 items-start">
      <div>
        <SectionHead num="04" eyebrow="Make it yours" title="Your company profile. Fully customisable."
          sub="Every business that signs up gets its own set-up. Change it any time from Settings — or tell us what you need and we'll set it up with you." />
        <Reveal delay={0.1} className="mt-10"><Profile /></Reveal>
        <div className="mt-8"><EmailSetupButton testid="home-customise-email-btn" tone="navy" label="Email us to set yours up" /></div>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {ITEMS.map(([Icon, t, p], i) => (
          <Reveal key={t} delay={0.04 * i}>
            <div className="h-full rounded-2xl border border-slate-200 bg-[#F8FAFC] p-6 hover:border-[#EA580C]/60 hover:-translate-y-0.5 transition-[transform,border-color] duration-300" data-testid={`home-customise-item-${i}`}>
              <span className="w-11 h-11 rounded-xl bg-[#FFEDD5] text-[#9A3412] grid place-items-center"><Icon className="w-5 h-5" /></span>
              <h3 className="font-display mt-4 text-lg font-bold">{t}</h3>
              <p className="mt-1 text-sm text-slate-600">{p}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
